
import { CareerSiteService, SearchJobResponse } from 'api-clients/monolith';
import { useEffect, useState } from 'react';

export function useJobsSearch(
  accountSlug: string,
  brandId: string,
  searchString: string,
  locale?: string,
) {
  const [data, setData] = useState<SearchJobResponse>();
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (!searchString.trim()) {
      setIsFetching(false);
      setData(undefined);
      return undefined;
    }

    // Guard to avoid setState on unmounted component and to drop stale results
    let isActive = true;
    const requestId = Symbol('jobs-search');

    setIsFetching(true);
    const fetchData = async (currentId: symbol) => {
      await CareerSiteService.getInternalApiCareerSiteSearchFunnelsByLocation(
        {
          account_slug: accountSlug,
          brand_id: brandId,
        },
        searchString,
        locale,
      )
        .then((result: SearchJobResponse) => {
          if (!isActive || currentId !== requestId) return; // ignore stale
          setData(result);
        })
        .catch(() => {
          // fetch error — not re-thrown
        })
        .finally(() => {
          if (!isActive || currentId !== requestId) return;
          setIsFetching(false);
        });
    };

    const timerId = setTimeout(() => {
      const currentId = requestId;
      fetchData(currentId).catch(() => {
        // Error already handled in fetchData
      });
    }, 300);

    return () => {
      isActive = false;
      clearTimeout(timerId);
      return undefined;
    };
  }, [accountSlug, brandId, searchString, locale]);

  return { data, isFetching };
}
